import React, { useMemo } from 'react';
import { HoiPoiProvider } from '@Sage/hoi-poi-ui';
import { createTheme } from "./styles/theme";
import Web5Context, { getContext } from "./Web5Context";
let Web5Provider = /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    context,
    theme
  } = _ref;
  const finalContext = useMemo(() => getContext(context), [context]);
  const hoipoiTheme = useMemo(() => createTheme(theme), [theme]);
  return /*#__PURE__*/React.createElement(Web5Context.Provider, {
    value: finalContext
  }, /*#__PURE__*/React.createElement(HoiPoiProvider, {
    theme: hoipoiTheme
  }, children));
});
export default Web5Provider;